module.exports = __webpack_public_path__ + "static/slack-328a2a3e32d520e26678032a2d1aa67f.svg";